import { State as _DataModalCustomerTariffPlans } from "./CustomerTariffPlans/dataModal/interface";

export namespace SettingsFinances {
	export namespace CustomerTariffPlans {
		export interface DataModalCustomerTariffPlans
			extends _DataModalCustomerTariffPlans {}
	}

	export const ConstantAccountsSlice = {
		SETTINGS_MENU_FINANCES_CUSTOMER_TARIFF_PLANS_DATA_MODAL:
			"settingsMenu/finances/customerTariffPlans/dataModal",
	};
}
